import React from 'react';
import Link from 'gatsby-link';
import format from 'date-fns/format';

import './blog-post-hero.scss';

const Hero = ({ imageUrl, title, author, date, excerpt, featured, category, slug, link }) => {
  const backgroundImgStyle = {
    backgroundImage: `url("${imageUrl}?fm=jpg&q=80&w=1440&h=900&fl=progressive")`
  };

  const body = (
    <div>
      <div className="blog-post-hero__overlay" />
      <div className="link--no-decoration">
        <h1 className="blog-post-hero__title">
          {title}
        </h1>
      </div>
      <div className="blog-post-hero__wrap">
        <div className="blog-post-hero__excerpt">
          {excerpt}
        </div>
        <div className="blog-post-hero__details">
          {category}
          <span>•</span>
          {format(date, 'MMMM D, YYYY')}
          <span>•</span>
          By {author}
        </div>
        <div className="blog-post-hero__sharer">
          <a
            className="social-icon"
            href={`https://twitter.com/intent/tweet?url=https://www.thefarmproject.com/blog/{slug}`}
            target="_blank"
          >
            <i className="fab fa-twitter" />
          </a>
          <a
            className="social-icon"
            href={`https://www.facebook.com/sharer.php?u=https://www.thefarmproject.com/blog/{slug}`}
            target="_blank"
          >
            <i className="fab fa-facebook" />
          </a>
        </div>
        <div className="blog-post-hero__link">
          Read More
          <i className="fas fa-chevron-right" />
        </div>
      </div>
    </div>
  );


  if(link == false){
    return (
      <div
        className="blog-post-hero blog-post-hero--featured"
        style={backgroundImgStyle}
      >
        {body}
      </div>
    );
  } else {
    return (
      <div
        className="blog-post-hero blog-post-hero--featured"
        style={backgroundImgStyle}
      >
        <Link to={`/blog/${slug}`}>
          {body}
        </Link>
      </div>
    );
  };
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/blog-post-hero.js